import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.title}}",{ moduleName: "discourse/components/modal-tab.hbs" })